import Vue from 'vue';
import Vuex from 'vuex';

import customerStatus from './modules/customer_status';
import portfolioTypes from './modules/portfolio_types';
import subStatuses from './modules/sub_statuses';
import accountTypes from './modules/account_types';
import companyLoad from './modules/company_load';
import intentions from './modules/intentions';
import dimentions from './modules/dimentions';
import currencies from './modules/currencies';
import ageGroups from './modules/age_groups';
import dueDates from './modules/due_dates';
import tranches from './modules/tranches';
import agencies from './modules/agencies';
import channels from './modules/channels';
import download from './modules/download';
import genders from './modules/genders';
import charts from './modules/charts';
import status from './modules/status';
import trancheStatus from './modules/tranche_status';
import agents from './modules/agents';
import states from './modules/states';
import bills from './modules/bills';
import app from './modules/app';
import containmentState from './modules/containment-states';
import moduleDialer from './dialer/moduleDialer';
import dialerV2 from './dialer_v2';
import refinancing from './modules/refinancing';
import inboundStatuses from './modules/inbound_statuses';
import user from './modules/user';
import noPaymentReasons from './modules/no_payment_reasons';
import chatCenterConfig from './modules/chat_center_config';
import callTimeAndAlert from './call_time_and_alert';
import answerTemplates from './modules/answer_templates';
import chatCenterState from './modules/chat_center_state';
import manualCalls from './manual_calls';
import entityStatuses from './modules/entity_statuses';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    customerStatus,
    portfolioTypes,
    trancheStatus,
    subStatuses,
    accountTypes,
    companyLoad,
    intentions,
    currencies,
    dimentions,
    ageGroups,
    dueDates,
    tranches,
    agencies,
    channels,
    download,
    genders,
    status,
    states,
    agents,
    charts,
    bills,
    app,
    containmentState,
    dialer: moduleDialer,
    dialerV2,
    refinancing,
    inboundStatuses,
    user,
    noPaymentReasons,
    chatCenterConfig,
    callTimeAndAlert,
    answerTemplates,
    chatCenterState,
    manualCalls,
    entityStatuses,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js